import parachuteLogo from "../assets/parachute-logo-small.png";

const MobileBlockPage = (): JSX.Element => (
  <div
    className="min-h-screen w-full flex items-center justify-center px-6"
    style={{ backgroundColor: "#EAEAEA" }}
  >
    <div className="flex flex-col items-center text-center max-w-md space-y-4">
      <img
        src={parachuteLogo}
        alt="Parachute logo"
        className="h-20 w-20 object-contain"
      />
      <h1 className="text-xl font-semibold text-neutral-darkest">
        {`This experience is optimized`}
        <br />
        {`for desktop.`}
      </h1>
      <p className="text-base text-neutral-dark">
        {`Please visit this site on a laptop`}
        <br />
        {`or desktop computer.`}
      </p>
    </div>
  </div>
);

export default MobileBlockPage;
